import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import {
  LeftColumnSection,
  LinksColumnSection,
  detailsFooterContentParser
} from '../componentSections/detailsFooterComponents';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';

const DetailsFooter = ({
  componentContent,
  handleClickFPTI,
  fptiImpression,
  toolName,
  app
}) => {
  if (!componentContent) {
    return null;
  }
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: 'footer'
    });
  });

  const { title, subtitle } = componentContent;

  // temporary, after migration rename linksNew + subtitleLinksNew to links in schema and destructure it in the line above
  const links = componentContent.linksNew || componentContent.links,
    subtitleLink =
      componentContent.subtitleLinkNew || componentContent.subtitleLink;

  const buffSubLinkData = parseData(subtitleLink)[0] || {};

  if (!links || !title) {
    fireDetailsPageComponentFailureFpti({
      data: { links, title },
      componentName: 'DetailsFooter',
      fptiImpression
    });
    return null;
  }

  const linkItemValuesPair = links ? detailsFooterContentParser(links) : [];

  return (
    <div id="details-footer-solution">
      <div className="details-footer-container" ref={ref}>
        <LeftColumnSection
          questionsLabel={title}
          helpLabel={subtitle}
          handleClickFPTI={handleClickFPTI}
          subtitleLink={buffSubLinkData}
          app={app}
        />
        {linkItemValuesPair.length > 0 &&
          linkItemValuesPair.map((item, index) => (
            <LinksColumnSection
              key={`details-footer-item${index}`}
              linkItems={item}
              handleClickFPTI={handleClickFPTI}
              toolName={toolName}
              app={app}
            />
          ))}
      </div>
    </div>
  );
};

DetailsFooter.propTypes = {
  componentContent: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  fptiImpression: PropTypes.func.isRequired,
  toolName: PropTypes.string,
  app: PropTypes.object
};

export default DetailsFooter;
